module.exports = __webpack_public_path__ + "img/max_logo.1c80599c.png";